import { useId, type ReactElement, type ReactNode } from "react";
import { palette, space } from "@ux/tokens";
import { Stack } from "./Stack";
import { Text } from "./Text";

export interface FormFieldProps {
    readonly label: string;
    readonly htmlFor?: string;
    readonly required?: boolean;
    readonly hint?: string;
    readonly error?: string;
    readonly children: (controlId: string) => ReactNode;
}

export function FormField({
    label,
    htmlFor,
    required = false,
    hint,
    error,
    children,
}: FormFieldProps): ReactElement {
    const generatedId = useId();
    const controlId = htmlFor ?? generatedId;

    return (
        <Stack direction="column" gap={1}>
            <Text role="label" htmlFor={controlId}>
                {label}
                {required ? (
                    <span style={{ color: palette.danger, marginLeft: space[1] }}>*</span>
                ) : null}
            </Text>
            {children(controlId)}
            {error !== undefined && error !== "" ? (
                <Text role="muted" color={palette.danger}>
                    {error}
                </Text>
            ) : hint !== undefined ? (
                <Text role="muted">{hint}</Text>
            ) : null}
        </Stack>
    );
}
